export default {"src":"/_next/static/media/personality-trait.981239af.svg","height":99,"width":88,"blurWidth":0,"blurHeight":0};